import { PageHeader } from "@/components/shared/page-header";
import { TemplateForm } from "@/components/templates/TemplateForm";

export function NewTemplatePage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="New Template"
        description="Create an audit template with sections and checklist items."
      />
      <TemplateForm />
    </div>
  );
}
